// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"6ac3bb14","239":"c5f68727","453":"825386d9","455":"a586c8e4","977":"7eff1642"}[chunkId] + ".chunk.js";
};